import Vue from 'vue';
import Main from './main.vue';
let MessageConstructor = Vue.extend(Main);
let instance = null;
const Message = function(options = {}, cb = function() {}) {
  if(typeof options === 'string') {
    options = {
      message: options
    }
  }
  instance = new MessageConstructor({
    data: options,
    methods: {cb}
  })
  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  instance.isShow = true
  return instance.vm
}

export default Message;